import { Component, OnInit } from '@angular/core';
import { NavigationStart, Router, RouterEvent } from '@angular/router';
import { MenuItem, MessageService } from 'primeng/api';
import { EMPTY, Observable, of } from 'rxjs';
import { catchError, filter, isEmpty, map, mergeMap, switchMap } from 'rxjs/operators';
import { toQueryParams } from './_helpers/date-utils';
import { getDefaultDateFilters } from './_helpers/default-params';
import { User } from './_models';
import { Role } from './_models/role';
import { AuthenticationService } from './_services';
import pl from './common/pl.locale';
import { PrimeNGConfig } from 'primeng/api';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  title = 'worklogs';
  items: MenuItem[];

  constructor(
    public authenticationService: AuthenticationService,
    private router: Router,
    private config: PrimeNGConfig
  ) {}

  $loggedUser: Observable<User>;
  $isLogged: Observable<boolean>;

  ngOnInit(): void {
    this.$loggedUser = this.authenticationService.loggedUser;
    this.$isLogged = this.$loggedUser.pipe(map((user) => !!user));
    this.$loggedUser.pipe(filter((user) => !!user)).subscribe((user) => {
      this.setItems(user.role);
    });
    this.config.setTranslation(pl);
  }

  setItems(role: Role | undefined): void {
    this.items = [
      {
        icon: 'pi pi-fw pi-home',
        routerLink: [''],
        styleClass: 'home-menubar-button',
        id: 'home-menubar-button',
      },
      {
        label: $localize`:user worklogs menu item|User worklogs menu item@@user-worklogs-menu-item:My month`,
        icon: 'pi pi-fw pi-calendar',
        routerLink: ['/users/worklogs'],
        queryParams: toQueryParams(getDefaultDateFilters()),
        visible: role === 'ROLE_EMPLOYEE',
      },
      {
        label: $localize`:worklogs menu item|Worklogs menu item@@worklogs-menu-item:Worklogs`,
        icon: 'pi pi-fw pi-calendar',
        queryParams: toQueryParams(getDefaultDateFilters()),
        routerLink: ['/worklogs'],
        visible: role === 'ROLE_ADMIN',
      },
      {
        label: $localize`:employees menu item|Employees menu item@@employees-menu-item:Employees`,
        icon: 'pi pi-fw pi-users',
        routerLink: ['users'],
        visible: role === 'ROLE_ADMIN',
      },
      {
        label: $localize`:profile menu item|Profile menu item@@profile-menu-item:Profile`,
        icon: 'pi pi-fw pi-user',
        routerLink: ['users', 'profile'],
      },
      {
        label: $localize`:change pwd menu item|Change pwd menu item@@change-pwd-menu-item:Change password`,
        icon: 'pi pi-fw pi-key',
        routerLink: ['users', 'change-password'],
      },
      {
        label: $localize`:logout menu item|Logout menu item@@logout-menu-item:Logout`,
        icon: 'pi pi-fw pi-sign-out',
        command: () => {
          this.authenticationService.logout();
          this.router.navigate(['/login']);
        },
      },
    ];
  }
}
